function flattenObject({ obj, prefix = "" }: { obj: any; prefix?: string }): undefined | Record<string, string> {
	if (!obj) return;

	const raw = Object.keys(obj).reduce((params, key) => {
		const pre = prefix.length ? prefix + "." : "";
		const value = obj[key];
		if (typeof value === "object") {
			if (Array.isArray(value)) {
				const valueMapped = value.map((item) => `"${item}"`).join(", ");
				params[pre + key] = `${valueMapped}`;
			} else {
				const valueFlattened = flattenObject({ obj: value, prefix: pre + key });
				Object.assign(params, valueFlattened);
			}
		} else {
			if (typeof value === "boolean") {
				params[pre + key] = value;
			} else if (typeof value === "number") {
				params[pre + key] = value;
			} else {
				params[pre + key] = String(value);
			}
		}
		return params;
	}, {});

	return raw;
}

function clearObjectEmptyStrings({ obj }: { obj: any }) {
	if (!obj) return;

	const objEntries = Object.entries(obj).map(([key, value]) => {
		if (typeof value === "string" && (value as string).length === 0) {
			return [key, null];
		}

		if (typeof value === "object" && Array.isArray(value) === false) {
			const newValue = clearObjectEmptyStrings({ obj: value });
			return [key, newValue];
		}

		return [key, value];
	});

	return Object.fromEntries(objEntries);
}

/**
 * Make all properties in T optional. Deep version.
 */
export type DeepPartial<T> = {
	[P in keyof T]?:
		| (T[P] extends Array<infer U> ? Array<DeepPartial<U>> : T[P] extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>> : DeepPartial<T[P]>)
		| (() => string);
};

export const CommonUtil = { flattenObject, clearObjectEmptyStrings };
